// src/stores/graphFiltersStore.ts
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { GraphFiltersState } from '../types/store/graphFilters.types'

// Persisted per-graph edge-filter preferences. Right now this only tracks the
// "Min strength" slider, keyed by a stable graph identity (saved-graph id or
// chat conversation id) so each graph reopens at the strength the user left it.
export const useGraphFiltersStore = create<GraphFiltersState>()(
  devtools(
    persist(
      (set, get) => ({
        minStrengthByGraph: {},

        getMinStrength: (key) => get().minStrengthByGraph[key],

        setMinStrength: (key, value) =>
          set((state) => {
            if (state.minStrengthByGraph[key] === value) return state
            return {
              minStrengthByGraph: { ...state.minStrengthByGraph, [key]: value },
            }
          }),
      }),
      { name: 'graph-filters-storage' },
    ),
    { name: 'GraphFiltersStore', enabled: import.meta.env.DEV },
  ),
)
